import React, { useState, useEffect, useContext } from 'react'
import { useLocation, useRouteMatch } from 'react-router-dom'
import { Row, Col, Button } from 'react-bootstrap'
import objectPath from 'object-path'
import Swal from 'sweetalert2'
import { JsonForms } from '@jsonforms/react'
import { materialCells } from '@jsonforms/material-renderers'
import { DesignContext } from 'contexts/DesignContext'
import { generateString, isNumber } from 'designer/component/action/Data'
import FeatherIcon from 'feather-icons-react'
import PNotify from 'pnotify/dist/es/PNotify'
import 'designer/styles/dynamic.css'
import httpClient from 'utility/httpClient.util'
import cloneDeep from 'clone-deep'
import { createDesignerData } from 'designer/component/action/Design'
import ModalComponent from 'designer/component/component/Modal'
import {
  checkHasShow,
  checkIsShow,
  onCheckCondition,
  onUpdateCondition,
} from 'designer/component/action/condition/Action'
import { debounceCallback } from 'utility/debounceCallback.util'
import { updateCalculate } from 'designer/component/action/condition/Calculate'
import { isEmpty } from 'designer/component/action/condition/State'
import { fetchData } from 'designer/component/element/button/API'
import { getShowUiConfig } from 'designer/component/action/Config'
import useAuth from 'hooks/useAuth'

const PanelSample = (props) => {
  let { uischema, schema, renderers, showUi, editUi, designerUi = [] } = props
  let {
    dynamicIndex,
    dynamicName,
    isDynamic,
    isArray,
    arrayName,
    onUpdateFormData,
  } = props?.config || {}

  const fieldName = isArray
    ? `@${arrayName}.${uischema.name}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.name}`
    : uischema.name
  const fieldKey = isArray
    ? `@${arrayName}.${uischema.key}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.key}`
    : uischema.key

  let {
    firstDelete = false,
    panelPattern,
    panelWidth,
    buttonPosition,
    cardColor,
    confirmDelete = false,
    cloneButton,
    confirmClone = false,
    buttonArrange,
    deleteButton,
    deleteType,
    selectButton,
    editButton,
    filterList = [],
    apiGroup,
    saveButton,
    saveType,
    confirmSave = false,
    confirmCancel = false,
    firstAuto = false,
    filterPanel,
    editAction,
    editActionType,
    addActionType,
    isShowHeaderField,
    numberOrder,
    startSeq = 1,
  } = uischema

  const panelRefId = uischema?.deleteRefId || uischema?.panelRefId
  const { config } = useAuth()
  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    setFormData,
    setComponentPropsData,
    setIsLoading,
    isAddDynamic,
    setIsAddDynamic,
    keywordFilter = '',
    setIsUpdateDynamic,
    setAllData,
    allData,
    elementAction,
    setOpenModal,
    setDesignerPropsData,
    findUischemaIndex,
    searchData,
    setUischema,
    isUiChanged,
    setIsUiChanged,
    widgetName,
  } = designContext
  const isOpenModal = designContext.openModal

  const { formData = {}, designerPropsData } = jsonForm
  const [tempFormData, setTempFormData] = useState(cloneDeep(formData))
  const [tempDynamic, setTempDynamic] = useState(
    objectPath.get(cloneDeep(formData), uischema.name)
  )
  const match = useRouteMatch()
  const location = useLocation()

  const search = location.search || []
  const receivePathParams = match.params
  const urlSearchParams = new URLSearchParams(search)
  const receiveQueryParams = Object.fromEntries([...urlSearchParams])
  const allParams = { ...receivePathParams, ...receiveQueryParams }
  const [hoverPanel, setHoverPanel] = useState(null)
  const [showElements, setShowElements] = useState([])
  const headerField = objectPath.get(showElements, 0)
  const [editElements, setEditElements] = useState([])
  const [filterDynamic, setFilterDynamic] = useState([])
  let editElementList = editUi?.elements || []
  const editElement = editElementList.concat(designerUi)

  const viewUi = objectPath.get(isUiChanged, [
    'viewListItem',
    uischema.dynamicKey,
    'uiItem',
  ])
  const viewKey = objectPath.get(isUiChanged, [
    'viewListItem',
    uischema.dynamicKey,
    'viewKey',
  ])

  let hasViewDynamic = viewUi?.name
    ? objectPath.has(isUiChanged, [
        'viewListItem',
        uischema.dynamicKey,
        'item',
        viewUi.name,
      ])
    : false
  let viewDynamic = hasViewDynamic
    ? uischema.dynamicKey === uischema.key
      ? objectPath.get(formData, `${viewKey}.${uischema.name}`)
      : objectPath.get(
          formData,
          `${viewKey}.${dynamicName}.${dynamicIndex}.${uischema.name}`
        )
    : null

  let fullDynamicKey =
    uischema.dynamicKey === uischema.key
      ? `${uischema.name}`
      : dynamicName
      ? `${dynamicName}.${dynamicIndex}.${uischema.name}`
      : uischema.name

  let dynamicData = viewDynamic
    ? viewDynamic
    : objectPath.has(formData, uischema.key)
    ? fullDynamicKey
      ? objectPath.get(formData, fullDynamicKey)
      : objectPath.get(formData, uischema.key)
    : objectPath.get(formData, uischema.name) || []
  dynamicData = Array.isArray(dynamicData) ? dynamicData : []

  const [isClone, setIsClone] = useState(null)
  const [render, setRender] = useState(false)
  const [isAction, setIsAction] = useState(false)
  const [isCalTotal, setIsCalTotal] = useState(false)
  const [isInitial, setIsInitial] = useState(false)
  const isOnChange = objectPath.get(
    isUiChanged,
    `isOnDynamicChange.${uischema.key}`
  )
  const isRender = objectPath.get(isUiChanged, [uischema.key, 'isRender'])
  const isRefreshDynamic = objectPath.get(isUiChanged, [
    uischema.key,
    'isRefreshDynamic',
  ])

  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let isEnable = hasEnable
    ? objectPath.get(elementAction, ['isEnable', uischema.key])
    : true

  let numberStyle = {
    minWidth: '50px',
    display: 'flex',
  }
  let dynamicZindex = uischema?.zIndex === 0 ? 99 : uischema?.zIndex

  useEffect(() => {
    if (render) {
      setRender(false)
    }
  }, [render])

  useEffect(() => {
    if (viewKey) return
    if (!isOpenModal) {
      setModalDynamicIndex(null)
    }
    if (isAction) return setIsAction(false)
    setIsLoading(true)
    setFilterPanel(keywordFilter, dynamicData)
    setIsLoading(false)
  }, [dynamicData, isOpenModal])

  useEffect(() => {
    if (!viewKey) return
    if (!viewDynamic) return
    setFilterPanel(keywordFilter, viewDynamic)
  }, [viewKey])

  useEffect(() => {
    if (isRender) {
      setFilterPanel(keywordFilter, dynamicData)
    }
  }, [isRender])

  useEffect(() => {
    if (!isRefreshDynamic) return
    objectPath.del(isUiChanged, [uischema.key, 'isRefreshDynamic'])
    setIsUiChanged(isUiChanged)
    setIsLoading(true)
    refreshDynamicPanel(dynamicData).finally(() => setIsLoading(false))
  }, [isRefreshDynamic])

  useEffect(() => {
    if (viewKey) return
    setIsLoading(true)
    if (tempDynamic && tempDynamic.length > 0) {
      setFilterPanel(keywordFilter, tempDynamic)
      setIsAction(true)
    }
    setIsLoading(false)
  }, [keywordFilter])

  useEffect(() => {
    if (isAddDynamic === uischema.key) {
      setIsLoading(true)
      let newShowKey = showUi.tagname + generateString(5)
      let newShowElements = [
        ...showElements,
        {
          ...showUi,
          key: newShowKey,
          name: newShowKey,
          isNew: true,
          isWaitForSave: editButton ? true : false,
          data: { ...isClone },
          isClone: isClone ? true : false,
        },
      ]
      let newEditKey = editUi.tagname + generateString(5)
      let newEditElements = [
        ...editElements,
        {
          ...editUi,
          elements: editElement,
          key: newEditKey,
          name: newEditKey,
          data: { ...isClone },
          isClone: isClone ? true : false,
        },
      ]
      setShowElements(newShowElements)
      setEditElements(newEditElements)
      setIsLoading(false)
      setIsClone(null)
      if (!editButton) {
        setIsAddDynamic(false)
      }
    }
  }, [isAddDynamic])

  const postAPI = async (apiGroup, formData) => {
    let promiseList = []

    apiGroup.map(async (item) => {
      let promise = new Promise(async (resolve, reject) => {
        let response = await postData(item, formData)
        let data, message, status

        if (response) {
          data = response.data
          message = response.message
          status = response.status
        }

        if (!status || status >= 400) {
          reject({
            status: status,
            data: null,
            message: message,
            api: item.api,
            apiName: item.apiName,
            isUpdatePanel: false,
          })
          let notice = PNotify.error({
            title: 'Error',
            text: JSON.stringify(message, null, 2) || `Failed to create}`,
            icon: 'fas fa-exclamation-circle fa-xl',
          })
          notice.on('click', function () {
            notice.close()
          })
        } else {
          resolve({
            status: status,
            data: data,
            message: message,
            api: item.api,
            apiName: item.apiName,
            isUpdatePanel: true,
          })
          let notice = PNotify.success({
            title: 'Success',
            text: `Create Successfully`,
            icon: 'fas fa-check-circle fa-xl',
          })
          notice.on('click', function () {
            notice.close()
          })
        }
      })
        .then((response) => response)
        .catch((error) => error)
      promiseList.push(promise)
    })

    return await Promise.all(promiseList)
  }

  const postData = async (action, request) => {
    let api = setApi(action, request)
    if (!api) return
    let { headers = [] } = action
    let config = {}
    if (headers.length > 0) {
      headers.forEach(({ key, value }) => {
        if (key) {
          objectPath.set(config, `headers.${key}`, value)
        }
      })
    }
    let response = await httpClient
      .post(api, request, config)
      .then((data) => data)
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })
    return response
  }

  const putAPI = async (apiGroup, formData) => {
    let promiseList = []

    apiGroup.map(async (item) => {
      let promise = new Promise(async (resolve, reject) => {
        let response = await putData(item, formData)
        let data, message, status

        if (response) {
          data = response.data
          message = response.message
          status = response.status
        }

        if (!status || status >= 400) {
          reject({
            status: status,
            data: null,
            message: message,
            api: item.api,
            apiName: item.apiName,
            isUpdatePanel: false,
          })
          let notice = PNotify.error({
            title: 'Error',
            text: JSON.stringify(message, null, 2) || `Failed to update`,
            icon: 'fas fa-exclamation-circle fa-xl',
          })
          notice.on('click', function () {
            notice.close()
          })
        } else {
          resolve({
            status: status,
            data: data,
            message: message,
            api: item.api,
            apiName: item.apiName,
            isUpdatePanel: true,
          })
          let notice = PNotify.success({
            title: 'Success',
            text: `Update Successfully`,
            icon: 'fas fa-check-circle fa-xl',
          })
          notice.on('click', function () {
            notice.close()
          })
        }
      })
        .then((response) => response)
        .catch((error) => error)
      promiseList.push(promise)
    })

    return await Promise.all(promiseList)
  }

  const putData = async (action, request) => {
    let api = setApi(action, request)
    if (!api) return
    let { headers = [] } = action
    let config = {}
    if (headers.length > 0) {
      headers.forEach(({ key, value }) => {
        if (key) {
          objectPath.set(config, `headers.${key}`, value)
        }
      })
    }
    let response = await httpClient
      .put(api, request, config)
      .then((data) => data)
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })
    return response
  }

  const deleteAPI = async (apiGroup, formData) => {
    let promiseList = []

    apiGroup.map(async (item) => {
      let promise = new Promise(async (resolve, reject) => {
        let response = await deleteData(item, formData)
        let data, message, status

        if (response) {
          data = response.data
          message = response.message
          status = response.status
        }

        if (!status || status >= 400) {
          reject({
            status: status,
            data: null,
            message: message,
            api: item.api,
            apiName: item.apiName,
            isUpdatePanel: false,
          })
          let notice = PNotify.error({
            title: 'Error',
            text: JSON.stringify(message, null, 2) || 'Failed Delete',
            icon: 'fas fa-exclamation-circle fa-xl',
          })
          notice.on('click', function () {
            notice.close()
          })
        } else {
          resolve({
            status: status,
            data: data,
            message: message,
            api: item.api,
            apiName: item.apiName,
            isUpdatePanel: true,
          })
          let notice = PNotify.success({
            title: 'Success',
            text: 'Delete Successfully',
            icon: 'fas fa-check-circle fa-xl',
          })
          notice.on('click', function () {
            notice.close()
          })
        }
      })
        .then((response) => response)
        .catch((error) => error)
      promiseList.push(promise)
    })

    return await Promise.all(promiseList)
  }

  const setApi = (
    {
      apiType,
      api = '',
      service = '',
      endpoint = '',
      pathParams = [],
      queryParams = [],
    },
    formData
  ) => {
    if (apiType === 'internal') {
      api = service + endpoint
    }

    if (pathParams) {
      pathParams.forEach(
        ({ param, key, propType = '', value, prefixValue = '' }) => {
          if (!param) return
          if (propType === 'urlParam') {
            value = objectPath.get(allParams, key) || null
          } else if (propType === 'dynamic') {
            value = objectPath.get(formData, param) || null
          }
          if (value && prefixValue && !value.startsWith(prefixValue)) {
            value = prefixValue + value
          }
          if (api.search(`:${param}`) > -1) {
            api = api.replace(`:${param}`, value)
          }
          if (api.search(`{${param}}`) > -1) {
            api = api.replace(`{${param}}`, value)
          }
        }
      )
    }
    if (queryParams) {
      let query = []
      queryParams.forEach(
        ({ param, key, propType = '', value, prefixValue = '' }) => {
          if (!param) return
          if (propType === 'urlParam') {
            value = objectPath.get(allParams, key) || null
            if (value && prefixValue && !value.startsWith(prefixValue)) {
              value = prefixValue + value
            }
            query.push(`${param}=${value}`)
          } else if (propType === 'dynamic') {
            value = objectPath.get(formData, param) || null
            if (value && prefixValue && !value.startsWith(prefixValue)) {
              value = prefixValue + value
            }
            query.push(`${param}=${value}`)
          }
        }
      )

      let connect = api.indexOf('?') > -1 ? '&' : '?'
      api = query.length > 0 ? api + connect + query.join('&') : api
    }

    return api
  }

  const getFetchDynamicData = (formData = {}) => {
    if (objectPath.has(formData, uischema.name)) {
      return objectPath.get(formData, uischema.name)
    }
    if (objectPath.has(formData, uischema.key)) {
      return objectPath.get(formData, uischema.key)
    }
    return null
  }

  const refreshDynamicPanel = async (fallbackDynamic = null) => {
    let data = {
      formData: jsonForm.formData,
      urlParams: allParams,
      allParams,
    }
    let response = await fetchData({ data, designContext })
    let updatedDynamic = getFetchDynamicData(response?.data)
    if (Array.isArray(updatedDynamic)) {
      updatedDynamic = cloneDeep(updatedDynamic)
    } else if (Array.isArray(fallbackDynamic)) {
      updatedDynamic = cloneDeep(fallbackDynamic)
    } else {
      return fallbackDynamic
    }
    setTempDynamic(updatedDynamic)
    objectPath.set(tempFormData, uischema.name, updatedDynamic)
    setTempFormData(tempFormData)
    setFilterPanel(keywordFilter, updatedDynamic)
    calLength(updatedDynamic)
    return updatedDynamic
  }

  const createUpdatePanel = (index) => {
    setIsLoading(true)
    let element = objectPath.get(showElements, index)
    let isCloneSave = isClone || element.isClone
    let { isNew } = element
    let dataUpdate = objectPath.get(formData, `${uischema.name}.${index}`)
    if (objectPath.has(allData, [`${uischema.name}.${index}`])) {
      let data = objectPath.get(allData, [`${uischema.name}.${index}`])
      let { key, value } = data
      objectPath.set(dataUpdate, key, value)
      objectPath.del(allData, [`${uischema.name}.${index}`])
    }
    if (saveType === 'array') {
      if (isCloneSave) {
        setIsAddDynamic(false)
        objectPath.push(filterDynamic, '', dataUpdate)
        objectPath.set(showElements, `${index}.isNew`, false)
        objectPath.set(showElements, `${index}.isClone`, false)
      } else if (isNew) {
        setIsAddDynamic(false)
        objectPath.push(filterDynamic, '', dataUpdate)
        objectPath.set(showElements, `${index}.isNew`, false)
      } else {
        let tempId = filterDynamic.findIndex(
          (data) => JSON.stringify(data) === JSON.stringify(element.data)
        )
        if (tempId > -1) {
          objectPath.set(filterDynamic, tempId, dataUpdate)
        }
      }
      objectPath.set(showElements, `${index}.isWaitForSave`, false)
      setFilterDynamic(filterDynamic)
      setFilterPanel(keywordFilter, filterDynamic)
      setTempDynamic(filterDynamic)
      objectPath.set(tempFormData, uischema.name, filterDynamic)
      setTempFormData(filterDynamic)
      setWaitingIndex(null)
      setIsAction(true)
    } else if (saveType === 'api') {
      let tempId = -1
      let promiseList = null
      if (isCloneSave) {
        tempId = index
        setIsAddDynamic(false)
        let apiCreate = apiGroup.filter(({ isCreate = false }) => isCreate)
        promiseList = postAPI(apiCreate, dataUpdate)
      } else if (isNew) {
        setIsAddDynamic(false)
        let apiCreate = apiGroup.filter(({ isCreate = false }) => isCreate)
        promiseList = postAPI(apiCreate, dataUpdate)
      } else {
        let apiUpdate = apiGroup.filter(({ isUpdate = false }) => isUpdate)
        promiseList = putAPI(apiUpdate, dataUpdate)
        if (tempDynamic) {
          tempId = tempDynamic.findIndex(
            (tempData) =>
              JSON.stringify(tempData) == JSON.stringify(element.data)
          )
        }
        tempId = tempId === -1 ? index : tempId
      }
      if (promiseList) {
        promiseList.then(async (response) => {
          let updatedDynamic = Array.isArray(tempDynamic)
            ? cloneDeep(tempDynamic)
            : Array.isArray(dynamicData)
            ? cloneDeep(dynamicData)
            : []
          response.forEach(({ data }) => {
            if (data) {
              if (tempId === -1) {
                objectPath.push(updatedDynamic, '', data)
              } else {
                objectPath.set(updatedDynamic, tempId, data)
              }
            }
          })
          await refreshDynamicPanel(updatedDynamic)
        })
        setIsAction(true)
        setWaitingIndex(null)
      }
    }
  }

  const [waitingIndex, setWaitingIndex] = useState(null)
  const [modalDynamicIndex, setModalDynamicIndex] = useState(null)
  const modalDynamicKey = `${uischema.key}.${modalDynamicIndex}`

  const getModal = (form, modalKey) => {
    let elements = form.uischema.elements
    let mapKey = form.schema.mapKey[modalKey]
    let indices = findUischemaIndex(modalKey, mapKey, elements)
    let modalElement = indices.reduce((o, i) => o.elements[i], { elements })
    return modalElement
  }

  const openEditModal = (index) => {
    setModalDynamicIndex(index)
    let modalKey = objectPath.get(editAction, 'modal.key')
    if (editAction.modalType === 'internal') {
      let elements = jsonForm.uischema.elements
      let modalElement = getModal(jsonForm, modalKey)
      modalElement.isOpen = true
      let newUiSchema = jsonForm.uischema
      newUiSchema.elements = elements
      setUischema(newUiSchema)
      setOpenModal(uischema.modal)
    } else if (editAction.modalType === 'external') {
      objectPath.set(designerPropsData, 'modal', editAction.formCode)
      let newDesignerPropsData = createDesignerData(
        designerPropsData,
        searchData,
        formData
      )
      setDesignerPropsData(newDesignerPropsData)
      let modalDynamicKey = `${uischema.key}.${index}`
      setOpenModal(modalDynamicKey)
    } else if (editAction.modalType === 'component') {
      objectPath.set(designerPropsData, 'modal', editAction.component)
      setDesignerPropsData(designerPropsData)
    }
  }

  const updateWaitingState = (index) => {
    if (waitingIndex) {
      let element = objectPath.get(showElements, waitingIndex)
      let { isNew, data, isClone } = element
      if (isClone) {
        setFilterDynamic(tempDynamic)
        objectPath.del(showElements, index)
        objectPath.del(editElements, index)
        setIsAddDynamic(false)
      } else if (isNew) {
        objectPath.del(tempFormData, index)
        objectPath.del(showElements, index)
        objectPath.del(editElements, index)
        setIsAddDynamic(false)
      } else {
        objectPath.set(filterDynamic, index, data)
        objectPath.set(showElements, `${waitingIndex}.isWaitForSave`, false)
        objectPath.set(showElements, `${waitingIndex}.isNew`, false)
      }
    }

    objectPath.set(showElements, `${index}.isWaitForSave`, true)
    objectPath.set(showElements, `${index}.isNew`, false)

    setShowElements(showElements)
    setRender(true)
    setWaitingIndex(index)
  }

  const clonePanel = (index) => {
    let dataClone = objectPath.get(formData, `${uischema.name}.${index}`)
    let newClone = cloneDeep(dataClone)
    objectPath.push(dynamicData, '', newClone)
    setFilterPanel(keywordFilter, dynamicData)
    setIsLoading(false)
    if (editButton) {
      let index = dynamicData.length - 1
      updateWaitingState(index)
      setIsClone(newClone)
    }
  }

  const selectPanel = (index) => {
    let componentPropsData = { data: formData, isSelected: true }
    let sendProps = designerPropsData?.send || []
    let foundProps = sendProps.filter(({ key }) => key === uischema.key)
    foundProps.forEach(({ prop, dynamicName }) => {
      let value = objectPath.get(formData, `${dynamicName}.${index}.${prop}`)
      objectPath.set(componentPropsData, `data.${prop}`, value)
    })
    setComponentPropsData(componentPropsData)
    setWaitingIndex(null)
  }

  const setFilterPanel = (
    keywordFilter,
    dynamicData = [],
    showElements = [],
    editElements = [],
    isReset = true
  ) => {
    setIsLoading(false)
    dynamicData = Array.isArray(dynamicData) ? dynamicData : []
    let filterData = dynamicData
    if (keywordFilter !== '') {
      const regex = new RegExp(keywordFilter, 'i')
      filterData = dynamicData.filter((item) => {
        let checkFilter = filterList.find(({ value }) => {
          let dataValue = objectPath.get(item, value)
          return regex.test(dataValue)
        })
        return checkFilter ? true : false
      })
    } else {
      setFilterDynamic([...filterData])
      setTempDynamic([...filterData])
    }

    if (filterData.length === 0 && keywordFilter === '') {
      if (firstAuto) {
        let newShowKey = showUi.tagname + generateString(5)
        showElements = [
          {
            ...showUi,
            isNew: true,
            isWaitForSave: false,
            key: newShowKey,
          },
        ]
        editElements = [editUi]
      }
    } else {
      if (isReset) {
        filterData.forEach((item = {}) => {
          let data = cloneDeep(item)
          let newShowKey = showUi.tagname + generateString(5)
          showElements.push({
            ...showUi,
            key: newShowKey,
            name: newShowKey,
            data: { ...data },
          })
          let newEditKey = editUi.tagname + generateString(5)
          editElements.push({
            ...editUi,
            elements: editElement,
            key: newEditKey,
            name: newEditKey,
            data: { ...data },
          })
        })
      } else {
        filterData.forEach((item = {}, index) => {
          let data = JSON.parse(JSON.stringify(item))
          objectPath.set(showElements, `${index}.data`, { ...data })
          objectPath.set(editElements, `${index}.data`, { ...data })
        })
      }
    }
    setShowElements([...showElements])
    setEditElements([...editElements])
    updatePanel(filterData)
  }

  const updatePanel = (dynamicData) => {
    dynamicData = Array.isArray(dynamicData) ? dynamicData : []
    let numberOrder = 1
    let seq = Number(startSeq)
    dynamicData.map((item) => {
      let isDeleted = objectPath.get(item, '@isDeleted') === 1
      if (isDeleted) return item
      objectPath.set(item, '@numberOrder', numberOrder)
      objectPath.set(item, '@seq', seq)
      numberOrder = numberOrder + 1
      seq = seq + 1
      return item
    })
    objectPath.set(formData, uischema.name, dynamicData)
    objectPath.set(formData, uischema.key, dynamicData)
    setFormData(formData)
    if (onUpdateFormData) {
      onUpdateFormData(uischema.name, dynamicData)
    }
    setIsLoading(false)
    setIsUpdateDynamic(uischema.name)
    calTotal(dynamicData)

    if (dynamicName) {
      let key = [dynamicName, dynamicIndex].join('.')
      objectPath.set(
        allData,
        [key, 'key'],
        ['jsonData', uischema.name].join('.')
      )
      objectPath.set(allData, [key, 'value'], dynamicData)
      setAllData(allData)
    }
  }

  const cancelPanel = (index) => {
    let element = objectPath.get(showElements, index)
    let { isNew, data, isClone } = element
    if (isClone) {
      setFilterDynamic(tempDynamic)
      objectPath.del(showElements, index)
      objectPath.del(editElements, index)

      setFilterPanel(
        keywordFilter,
        tempDynamic,
        showElements,
        editElements,
        false
      )
      setIsAddDynamic(false)
    } else if (isNew) {
      objectPath.del(tempFormData, index)
      objectPath.del(showElements, index)
      objectPath.del(editElements, index)
      setFilterPanel(
        keywordFilter,
        tempDynamic,
        showElements,
        editElements,
        false
      )
      setIsAddDynamic(false)
    } else {
      objectPath.set(filterDynamic, index, data)
      objectPath.set(showElements, `${index}.isWaitForSave`, false)
      setFilterPanel(
        keywordFilter,
        filterDynamic,
        showElements,
        editElements,
        false
      )
    }
    setIsAction(true)
    setWaitingIndex(null)
    setRender(true)
  }

  const deletePanelArray = (index) => {
    setIsLoading(true)
    let data = objectPath.get(formData, `${uischema.name}.${index}`)
    let isDeletedValue = 1
    let filterData = []
    if (filterPanel) {
      let tempId = filterDynamic.findIndex((tempData) => data === tempData)
      if (tempId > -1) {
        let refId = panelRefId
          ? objectPath.get(filterDynamic, `${tempId}.${panelRefId}`)
          : ''
        isDeletedValue = refId ? 1 : -1
        objectPath.set(filterDynamic, [tempId, '@isDeleted'], isDeletedValue)
      } else {
        let refId = panelRefId
          ? objectPath.get(filterDynamic, `${index}.${panelRefId}`)
          : ''
        isDeletedValue = refId ? 1 : -1
        objectPath.set(filterDynamic, [index, '@isDeleted'], isDeletedValue)
      }
      filterData = filterDynamic
    } else {
      let newDynamic = objectPath.get(formData, `${uischema.name}`)
      let refId = panelRefId
        ? objectPath.get(filterDynamic, `${index}.${panelRefId}`)
        : ''
      isDeletedValue = refId ? 1 : -1
      objectPath.set(newDynamic, [index, '@isDeleted'], isDeletedValue)
      filterData = newDynamic
    }
    filterData = filterData.filter(
      (item) => objectPath.get(item, '@isDeleted') !== -1
    )
    setFilterPanel(keywordFilter, filterData)
    setIsAction(true)
    setWaitingIndex(null)
  }

  const updateDeletePanel = (dynamicData = [], index) => {
    let updatedDynamic = Array.isArray(dynamicData)
      ? cloneDeep(dynamicData)
      : []
    if (index > -1) {
      objectPath.del(updatedDynamic, index)
    }
    if (updatedDynamic.length === 0) {
      setFilterDynamic([])
      setTempDynamic([])
      objectPath.set(tempFormData, uischema.name, [])
      setTempFormData(tempFormData)
      setShowElements([])
      setEditElements([])
      updatePanel([])
      calLength([])
      setIsAction(true)
      setIsLoading(false)
      return updatedDynamic
    }
    setTempDynamic(updatedDynamic)
    objectPath.set(tempFormData, uischema.name, updatedDynamic)
    setTempFormData(tempFormData)
    setFilterPanel(keywordFilter, updatedDynamic)
    calLength(updatedDynamic)
    setIsAction(true)
    setIsLoading(false)
    return updatedDynamic
  }

  const deletePanel = async (index) => {
    setIsLoading(true)
    let data = objectPath.get(formData, `${uischema.name}.${index}`)

    if (deleteType === 'array') {
      let tempId = filterDynamic.findIndex((tempData) => data === tempData)
      let isDeletedValue = 1
      if (tempId > -1) {
        let refId = panelRefId
          ? objectPath.get(filterDynamic, `${tempId}.${panelRefId}`)
          : ''
        isDeletedValue = refId ? 1 : -1
        objectPath.set(filterDynamic, [tempId, '@isDeleted'], isDeletedValue)
      } else {
        let refId = panelRefId
          ? objectPath.get(filterDynamic, `${index}.${panelRefId}`)
          : ''
        isDeletedValue = refId ? 1 : -1
        objectPath.set(filterDynamic, [index, '@isDeleted'], isDeletedValue)
      }
      if (isDeletedValue === -1) {
        updateDeletePanel(filterDynamic, tempId > -1 ? tempId : index)
      } else {
        setFilterPanel(keywordFilter, filterDynamic)
        setIsAction(true)
      }
    } else if (deleteType === 'api') {
      let element = objectPath.get(showElements, index)
      let currentDynamic = Array.isArray(tempDynamic) ? tempDynamic : []
      let tempId = currentDynamic.findIndex((tempData) => {
        if (panelRefId) {
          return (
            objectPath.get(tempData, panelRefId) ===
            objectPath.get(element.data, panelRefId)
          )
        }
        return JSON.stringify(tempData) === JSON.stringify(element.data)
      })
      let refId = panelRefId
        ? objectPath.get(element, ['data', panelRefId]) ||
          objectPath.get(data, panelRefId)
        : null
      let apiDelete = apiGroup.filter(({ isDelete = false }) => isDelete)
      let hasEmptyDeleteParam = apiDelete.find(
        ({ pathParams = [], queryParams = [] }) => {
          let deleteParams = pathParams.concat(queryParams)
          return deleteParams.find(({ propType = '', param }) => {
            if (propType !== 'dynamic') return false
            return isEmpty(objectPath.get(data, param))
          })
        }
      )
      if (
        apiDelete.length === 0 ||
        (panelRefId && isEmpty(refId)) ||
        hasEmptyDeleteParam
      ) {
        updateDeletePanel(currentDynamic, tempId > -1 ? tempId : index)
        setWaitingIndex(null)
        return
      }
      let promiseList = deleteAPI(apiDelete, data, index)
      promiseList.then(async (response) => {
        let updatedDynamic = currentDynamic
        let foundUpdatePanel = response.find(({ isUpdatePanel }) => {
          return isUpdatePanel
        })
        if (foundUpdatePanel) {
          updatedDynamic = updateDeletePanel(
            currentDynamic,
            tempId > -1 ? tempId : index
          )
        }
        await refreshDynamicPanel(updatedDynamic)
      })
    }
    setWaitingIndex(null)
  }

  const deleteData = async (action, formData) => {
    // set api
    let api = setApi(action, formData)
    if (!api) return
    // set request body

    let { headers = [] } = action
    let config = {}
    if (headers.length > 0) {
      headers.forEach(({ key, value }) => {
        if (key) {
          objectPath.set(config, `headers.${key}`, value)
        }
      })
    }

    let response = await httpClient
      .delete(api, config)
      .then((data) => data)
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })
    return response
  }

  const onDelete = (index) => {
    if (addActionType === 'modal' || editActionType === 'modal') {
      deletePanel(index)
    } else if (editButton) {
      deletePanel(index)
    } else {
      deletePanelArray(index)
    }
  }

  const openConfirmDelete = (index) => {
    Swal.fire({
      icon: 'warning',
      title: 'ลบรายการ',
      text: `คุณต้องการลบใช่หรือไม่?`,
      showCancelButton: true,
      confirmButtonText: 'ใช่',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'ไม่',
    }).then(async (result) => {
      if (result.isConfirmed) {
        onDelete(index)
      }
    })
  }

  const openConfirmCancel = (index) => {
    Swal.fire({
      icon: 'warning',
      title: 'ยกเลิกรายการ',
      text: `คุณต้องการยกเลิกใช่หรือไม่?`,
      showCancelButton: true,
      confirmButtonText: 'ใช่',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'ไม่',
    }).then(async (result) => {
      if (result.isConfirmed) {
        cancelPanel(index)
      }
    })
  }

  const openConfirmClone = (index) => {
    Swal.fire({
      icon: 'warning',
      title: 'Clone รายการ',
      text: `คุณต้องการ Clone ใช่หรือไม่?`,
      showCancelButton: true,
      confirmButtonText: 'ใช่',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'ไม่',
    }).then(async (result) => {
      if (result.isConfirmed) {
        clonePanel(index)
      }
    })
  }

  const openConfirmSave = (index) => {
    Swal.fire({
      icon: 'warning',
      title: 'บันทึกรายการ',
      text: `คุณต้องการบันทึกใช่หรือไม่?`,
      showCancelButton: true,
      confirmButtonText: 'ใช่',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'ไม่',
    }).then(async (result) => {
      if (result.isConfirmed) {
        createUpdatePanel(index)
      }
    })
  }

  const calTotal = (dynamicData) => {
    if (uischema.total && dynamicData) {
      let total = uischema.total
      total.forEach(({ dynamicField, totalField, hasCondition, condition }) => {
        if (!dynamicField || !totalField) return
        let totalValue = 0
        dynamicData.forEach((formValue) => {
          let isDelete = objectPath.get(formValue, '@isDeleted')
          if (isDelete) return
          let value = objectPath.get(formValue, dynamicField.value)
          if (isNumber(value)) {
            value = Number(value)
          }
          if (hasCondition && condition) {
            let foundCondition = condition.find((item) => {
              if (!item) return
              let {
                conditionField,
                conditionValue,
                compareType = 'equalValue',
              } = item
              if (!conditionField) return
              let itemValue =
                objectPath.get(formValue, conditionField.value) ||
                objectPath.get(formValue, conditionField.key)
              if (itemValue && isNumber(itemValue)) {
                itemValue = Number(itemValue)
              }
              if (conditionValue && isNumber(conditionValue)) {
                conditionValue = Number(conditionValue)
              }
              return compareTwoValue(compareType, itemValue, conditionValue)
            })
            if (foundCondition) {
              totalValue += value
            }
          } else {
            totalValue += value
          }
        })
        totalValue = parseFloat(totalValue.toFixed(2))
        objectPath.set(formData, totalField.key, totalValue)
        objectPath.set(formData, totalField.value, totalValue)
      })
      setFormData(formData)
      if (onUpdateFormData) {
        onUpdateFormData(uischema.name, dynamicData)
      }
      setIsCalTotal(true)
    }
  }

  const calLength = (dynamicData = []) => {
    if (uischema.fieldLength) {
      let fieldLength = uischema.fieldLength
      fieldLength.forEach(({ field }) => {
        if (!field) return
        let itemLength = 0
        if (dynamicData.length > 0) {
          let filterDynamic = dynamicData.filter((item) => {
            let isDeleted = objectPath.get(item, '@isDeleted')
            return isDeleted !== 1
          })
          itemLength = filterDynamic?.length || 0
        }
        objectPath.set(formData, field.key, itemLength)
        objectPath.set(formData, field.value, itemLength)
      })
      setFormData(formData)
      if (onUpdateFormData) {
        onUpdateFormData(uischema.name, dynamicData)
      }
    }
  }

  const compareTwoValue = (compareType, valueA, valueB) => {
    if (compareType === 'equalValue') {
      if (isEmpty(valueA) && isEmpty(valueB)) {
        return isEmpty(valueA) === isEmpty(valueB)
      }
      return valueA === valueB
    }
    if (compareType === 'notEqualValue') {
      if (isEmpty(valueA) && isEmpty(valueB)) {
        return isEmpty(valueA) !== isEmpty(valueB)
      }
      return valueA !== valueB
    }
    if (compareType === 'hasValue') return !isEmpty(valueA)
    if (compareType === 'emptyValue') return isEmpty(valueA)
  }

  const calDynamicValue = (dynamicData) => {
    let formulaList = uischema?.formula
    let calculate = uischema?.calculate
    if (!Array.isArray(dynamicData) || dynamicData.length === 0) return
    if (
      !formulaList ||
      !calculate ||
      formulaList.length === 0 ||
      calculate.length === 0
    )
      return
    let resultValueList = []
    dynamicData.map((formValue, formIndex) => {
      calculate.forEach((itemCalculate) => {
        if (!itemCalculate) return
        let {
          resultField,
          hasCondition,
          formula,
          condition = [],
        } = itemCalculate
        if (!resultField) return
        if (hasCondition) {
          let foundCondition = condition.find((item) => {
            if (!item) return
            let {
              conditionField,
              conditionValue,
              compareType = 'equalValue',
              formula,
            } = item
            if (!conditionField || !formula) return
            let itemValue =
              objectPath.get(formValue, conditionField.value) ||
              objectPath.get(formValue, conditionField.key)
            if (itemValue && isNumber(itemValue)) {
              itemValue = Number(itemValue)
            }
            if (conditionValue && isNumber(conditionValue)) {
              conditionValue = Number(conditionValue)
            }
            return compareTwoValue(compareType, itemValue, conditionValue)
          })
          if (foundCondition) {
            formula = foundCondition.formula
          }
        }
        if (formula) {
          let { data = [], link = [], name } = formula
          let resultValue = updateCalculate(
            data,
            link,
            formValue,
            jsonForm.formData
          )
          let resultKey = `${resultField.dynamicName}.${formIndex}.${resultField.value}`
          if (!resultValue) {
            resultValue = 0
          }
          objectPath.set(formData, resultKey, resultValue)
          resultValueList.push({ formIndex, name, resultValue })
        }
      })
    })
    setFormData(formData)
    if (onUpdateFormData) {
      onUpdateFormData(uischema.name, dynamicData)
    }
  }

  useEffect(() => {
    if (isOnChange) {
      objectPath.set(isUiChanged, `isOnDynamicChange.${uischema.key}`, false)
      setIsUiChanged(isUiChanged)
      calDynamicValue(dynamicData)
      calTotal(dynamicData)
    }
  }, [isOnChange])

  useEffect(() => calLength(dynamicData), [dynamicData?.length])

  useEffect(() => {
    if (isCalTotal) {
      setIsCalTotal(false)
      onUpdateCondition(props, designContext, uischema.key, formData, {
        isCheckOnlyCalculate: true,
      })
    }
  }, [isCalTotal])

  return (
    <>
      {panelPattern === 'down' && (
        <div
          className="pt-2 pb-3 w-100 mx-auto"
          style={{ minWidth: uischema.minWidth, maxWidth: uischema.maxWidth }}
        >
          <div className="pl-0">
            <Row
              className="m-0"
              style={{
                width:
                  (cloneButton || selectButton || saveButton || deleteButton) &&
                  isEnable
                    ? 'calc(100% - 75px)'
                    : 'calc(100% - 45px)',
              }}
            >
              {isShowHeaderField && headerField && (
                <>
                  {(Array.isArray(headerField.elements)
                    ? headerField.elements
                    : []
                  ).map((ui) => {
                    let hasShow = checkHasShow({
                      designContext,
                      uischema: ui,
                    })
                    let isShow = checkIsShow({ designContext, uischema: ui })
                    if (hasShow) {
                      if (!isShow) return
                    } else {
                      let isShowUi = getShowUiConfig({
                        uischema: ui,
                        config,
                        jsonForm,
                      })
                      if (!isShowUi) return
                    }
                    return (
                      <Col
                        id={`header-panel-${ui.key}`}
                        sm={ui.layoutWidth}
                        className="row px-0 d-flex mx-auto"
                        key={'dynamic-panel-' + ui.key}
                        style={{
                          padding: ui?.layoutPadding ?? '',
                          margin: ui?.layoutMargin ?? '',
                        }}
                      >
                        {ui.fieldName}
                      </Col>
                    )
                  })}
                </>
              )}
            </Row>
          </div>

          {showElements.map((value, index) => {
            let { isWaitForSave = false } = value
            let visibility =
              !firstDelete && index === 0 ? { visibility: 'hidden' } : {}
            let ui =
              isWaitForSave && editElements.length > 0
                ? editElements[index]
                : value
            let dataItem = objectPath.get(dynamicData, [index])
            let isDeleted = objectPath.get(dataItem, '@isDeleted')
            let no = objectPath.get(dataItem, '@numberOrder')
            if (isDeleted) {
              return
            }
            return (
              <Col
                id={`${fieldKey}-panel-${index}`}
                onMouseEnter={() => setHoverPanel(index)}
                onMouseLeave={() => setHoverPanel(null)}
                sm={showUi.layoutWidth}
                className="row px-0 d-flex mx-auto"
                key={'dynamic-panel-' + ui.key}
                style={{
                  padding: showUi?.layoutPadding ?? '',
                  margin: showUi?.layoutMargin ?? '',
                  zIndex: dynamicZindex - index,
                }}
              >
                {numberOrder === 'auto' && (
                  <Col sm="auto" className="pr-0 mt-2" style={numberStyle}>
                    <span>{no}</span>
                  </Col>
                )}
                <Col className="w-100 row pl-0">
                  <Col sm="auto" className="d-flex pl-0 w-100">
                    <div
                      style={{
                        width:
                          (cloneButton ||
                            selectButton ||
                            saveButton ||
                            deleteButton) &&
                          isEnable
                            ? 'calc(100% - 30px)'
                            : '100%',
                        borderRadius: '4px',
                        transition: 'all .2s',
                        border: isWaitForSave
                          ? `1px solid #FFB64D`
                          : `1px solid ${cardColor || 'transparent'}`,
                        boxShadow:
                          !isWaitForSave && hoverPanel === index
                            ? `1px 1px 3px ${cardColor || '#f8f9fa'}`
                            : '',
                      }}
                    >
                      <JsonForms
                        schema={schema}
                        uischema={ui}
                        config={{
                          dynamicId: `${fieldKey}-panel-${index}`,
                          dynamicData: dataItem,
                          dynamicName: uischema.name,
                          dynamicKey: uischema.key,
                          dynamicIndex: index,
                          fullDynamicKey: `${fullDynamicKey}.${index}`,
                          isFirstElement: false,
                          isSample: true,
                          viewKey: viewKey,
                          dynamicConfig: props?.config,
                        }}
                        renderers={renderers}
                        cells={materialCells}
                      />
                    </div>
                    {!isLocked &&
                      (cloneButton ||
                        selectButton ||
                        saveButton ||
                        deleteButton) &&
                      isEnable && (
                        <div
                          className="pt-1 mb-2 px-2"
                          style={{
                            width: '30px',
                            display: 'grid',
                            alignContent: buttonPosition,
                          }}
                        >
                          {cloneButton && isEnable && (
                            <Button
                              className="mb-1 py-0 px-1"
                              variant="outline-secondary"
                              disabled={isWaitForSave}
                              onClick={() => {
                                if (confirmClone) {
                                  openConfirmClone(index)
                                } else {
                                  clonePanel(index)
                                }
                              }}
                            >
                              <FeatherIcon icon="copy" size="14" />
                            </Button>
                          )}
                          {selectButton && isEnable && (
                            <Button
                              className="mb-1 py-0 px-1"
                              variant="outline-primary"
                              onClick={() => selectPanel(index)}
                              disabled={isWaitForSave}
                            >
                              <FeatherIcon icon="check-circle" size="14" />
                            </Button>
                          )}
                          {saveButton && isEnable && (
                            <>
                              {isWaitForSave ? (
                                <>
                                  <Button
                                    className="mb-1 py-0 px-1"
                                    variant="outline-success"
                                    onClick={() => {
                                      if (confirmSave) {
                                        openConfirmSave(index)
                                      } else {
                                        createUpdatePanel(index)
                                      }
                                    }}
                                  >
                                    <FeatherIcon icon="save" size="14" />
                                  </Button>
                                  {!deleteButton && (
                                    <Button
                                      className="py-0 px-1"
                                      style={{ ...visibility }}
                                      variant="outline-secondary"
                                      onClick={() => {
                                        if (confirmCancel) {
                                          openConfirmCancel(index)
                                        } else {
                                          cancelPanel(index)
                                        }
                                      }}
                                    >
                                      <FeatherIcon icon="x" size="14" />
                                    </Button>
                                  )}
                                </>
                              ) : (
                                <Button
                                  className="mb-1 py-0 px-1"
                                  variant="outline-warning"
                                  onClick={() => {
                                    if (editActionType === 'modal') {
                                      openEditModal(index)
                                    } else {
                                      updateWaitingState(index)
                                    }
                                  }}
                                >
                                  <FeatherIcon icon="edit" size="14" />
                                </Button>
                              )}
                            </>
                          )}
                          {deleteButton && isEnable && (
                            <>
                              {isWaitForSave ? (
                                <Button
                                  className="py-0 px-1"
                                  style={{ ...visibility }}
                                  variant="outline-secondary"
                                  onClick={() => {
                                    if (confirmCancel) {
                                      openConfirmCancel(index)
                                    } else {
                                      cancelPanel(index)
                                    }
                                  }}
                                >
                                  <FeatherIcon icon="x" size="14" />
                                </Button>
                              ) : (
                                <Button
                                  className="py-0 px-1"
                                  style={{ ...visibility }}
                                  variant="outline-danger"
                                  onClick={() => {
                                    if (confirmDelete) {
                                      openConfirmDelete(index)
                                    } else {
                                      onDelete(index)
                                    }
                                  }}
                                >
                                  <FeatherIcon icon="trash" size="14" />
                                </Button>
                              )}
                            </>
                          )}
                        </div>
                      )}
                  </Col>
                </Col>
              </Col>
            )
          })}
        </div>
      )}
      {panelPattern === 'right' && (
        <div
          className="d-flex mx-auto"
          style={{
            width: '100%',
            overflowX: 'auto',
            minWidth: uischema.minWidth,
            maxWidth: uischema.maxWidth,
          }}
        >
          {showElements.map((value, index) => {
            let visibility =
              !firstDelete && index === 0 ? { visibility: 'hidden' } : {}
            let { isWaitForSave = false } = value
            let ui =
              isWaitForSave && editElements.length > 0
                ? editElements[index]
                : value
            let dataItem = objectPath.get(dynamicData, [index])
            let isDeleted = objectPath.get(dataItem, '@isDeleted')
            if (isDeleted) {
              return
            }
            return (
              <div
                id={`${fieldKey}-panel-${index}`}
                onMouseEnter={() => setHoverPanel(index)}
                onMouseLeave={() => setHoverPanel(null)}
                style={{
                  minWidth: panelWidth,
                  width: panelWidth,
                  padding: showUi?.layoutPadding ?? '',
                  margin: showUi?.layoutMargin ?? '',
                }}
                key={'dynamic-panel-' + ui.key}
              >
                <Row className="w-100 mx-auto">
                  <Col
                    sm="12"
                    className="px-0 w-100"
                    style={{
                      borderRadius: '4px',
                      transition: 'all .2s',
                      border: isWaitForSave
                        ? `1px solid #FFB64D`
                        : `1px solid ${cardColor || 'transparent'}`,
                      boxShadow:
                        !isWaitForSave && hoverPanel === index
                          ? `1px 1px 3px ${cardColor || '#f8f9fa'}`
                          : '',
                    }}
                  >
                    <JsonForms
                      schema={schema}
                      uischema={ui}
                      config={{
                        dynamicId: `${fieldKey}-panel-${index}`,
                        dynamicData: dataItem,
                        dynamicName: uischema.name,
                        dynamicKey: uischema.key,
                        dynamicIndex: index,
                        fullDynamicKey: `${fullDynamicKey}.${index}`,
                        isFirstElement: false,
                        isSample: true,
                        viewKey: viewKey,
                        dynamicConfig: props?.config,
                      }}
                      renderers={renderers}
                      cells={materialCells}
                    />
                  </Col>
                  {!isLocked && (
                    <Col
                      sm="12"
                      className="w-100 pt-1 d-flex pb-2 px-2"
                      style={{ justifyContent: buttonPosition }}
                    >
                      {cloneButton && isEnable && (
                        <Button
                          className={`py-0 px-1 ${
                            buttonArrange === 'separate' ? 'mr-auto' : 'mr-1'
                          }`}
                          variant="outline-secondary"
                          disabled={isWaitForSave}
                          onClick={() => clonePanel(index)}
                        >
                          <FeatherIcon icon="copy" size="14" />
                        </Button>
                      )}
                      {selectButton && isEnable && (
                        <Button
                          className="py-0 px-1 mr-1"
                          variant="outline-primary"
                          onClick={() => selectPanel(index)}
                          disabled={isWaitForSave}
                        >
                          <FeatherIcon icon="check-circle" size="14" />
                        </Button>
                      )}
                      {saveButton && isEnable && (
                        <>
                          {isWaitForSave ? (
                            <>
                              <Button
                                className="mb-1 py-0 px-1 mr-1 h-100"
                                variant="outline-success"
                                onClick={() => {
                                  if (confirmSave) {
                                    openConfirmSave(index)
                                  } else {
                                    createUpdatePanel(index)
                                  }
                                }}
                              >
                                <FeatherIcon icon="save" size="14" />
                              </Button>
                              {!deleteButton && (
                                <Button
                                  className="py-0 px-1"
                                  style={{ ...visibility }}
                                  variant="outline-secondary"
                                  onClick={() => {
                                    if (confirmCancel) {
                                      openConfirmCancel(index)
                                    } else {
                                      cancelPanel(index)
                                    }
                                  }}
                                >
                                  <FeatherIcon icon="x" size="14" />
                                </Button>
                              )}
                            </>
                          ) : (
                            <Button
                              className="mb-1 py-0 px-1 mr-1 h-100"
                              variant="outline-warning"
                              onClick={() => {
                                if (editActionType === 'modal') {
                                  openEditModal(index)
                                } else {
                                  updateWaitingState(index)
                                }
                              }}
                            >
                              <FeatherIcon icon="edit" size="14" />
                            </Button>
                          )}
                        </>
                      )}
                      {deleteButton && isEnable && (
                        <>
                          {isWaitForSave ? (
                            <Button
                              className="py-0 px-1"
                              style={{ ...visibility }}
                              variant="outline-secondary"
                              onClick={() => {
                                if (confirmCancel) {
                                  openConfirmCancel(index)
                                } else {
                                  cancelPanel(index)
                                }
                              }}
                            >
                              <FeatherIcon icon="x" size="14" />
                            </Button>
                          ) : (
                            <Button
                              className="py-0 px-1"
                              style={{ ...visibility }}
                              variant="outline-danger"
                              onClick={() => {
                                if (confirmDelete) {
                                  openConfirmDelete(index)
                                } else {
                                  onDelete(index)
                                }
                              }}
                            >
                              <FeatherIcon icon="trash" size="14" />
                            </Button>
                          )}
                        </>
                      )}
                    </Col>
                  )}
                </Row>
              </div>
            )
          })}
        </div>
      )}
      {panelPattern === 'column' && (
        <Row
          className="w-100 mx-auto"
          style={{ minWidth: uischema.minWidth, maxWidth: uischema.maxWidth }}
        >
          {showElements.map((value, index) => {
            let visibility =
              !firstDelete && index === 0 ? { visibility: 'hidden' } : {}
            let { isWaitForSave = false } = value
            let ui =
              isWaitForSave && editElements.length > 0
                ? editElements[index]
                : value
            let dataItem = objectPath.get(dynamicData, [index])
            let isDeleted = objectPath.get(dataItem, '@isDeleted')
            if (isDeleted) {
              return
            }
            return (
              <Col
                sm={uischema?.panelLayoutWidth ?? 'auto'}
                // sm={uischema.panelLayoutWidth}
                className="p-0"
                id={`${fieldKey}-panel-${index}`}
                onMouseEnter={() => setHoverPanel(index)}
                onMouseLeave={() => setHoverPanel(null)}
                key={'dynamic-panel-' + ui.key}
                style={{
                  zIndex: dynamicZindex - index,
                }}
              >
                <Row className="w-100 mx-auto">
                  <Col
                    className="px-0 w-100 d-flex"
                    style={{
                      borderRadius: '4px',
                      transition: 'all .2s',
                      border: isWaitForSave
                        ? `1px solid #FFB64D`
                        : `1px solid ${cardColor || 'transparent'}`,
                      boxShadow:
                        !isWaitForSave && hoverPanel === index
                          ? `1px 1px 3px ${cardColor || '#f8f9fa'}`
                          : '',
                    }}
                  >
                    <div
                      className="d-flex w-100"
                      style={{ maxWidth: uischema.maxWidth ?? '100%' }}
                    >
                      <div className="w-100">
                        <JsonForms
                          schema={schema}
                          uischema={ui}
                          config={{
                            dynamicId: `${fieldKey}-panel-${index}`,
                            dynamicData: dataItem,
                            dynamicName: uischema.name,
                            dynamicKey: uischema.key,
                            dynamicIndex: index,
                            fullDynamicKey: `${fullDynamicKey}.${index}`,
                            isFirstElement: false,
                            isSample: true,
                            viewKey: viewKey,
                            dynamicConfig: props?.config,
                          }}
                          renderers={renderers}
                          cells={materialCells}
                        />
                      </div>
                      <div className="d-flex px-0 align-items-center">
                        {!isLocked && (
                          <Col
                            sm="auto"
                            className="w-100 d-flex px-0"
                            style={{ justifyContent: buttonPosition }}
                          >
                            {cloneButton && isEnable && (
                              <Button
                                className={`py-0 px-1 ${
                                  buttonArrange === 'separate'
                                    ? 'mr-auto'
                                    : 'mr-1'
                                }`}
                                variant="outline-secondary"
                                disabled={isWaitForSave}
                                onClick={() => clonePanel(index)}
                              >
                                <FeatherIcon icon="copy" size="14" />
                              </Button>
                            )}
                            {selectButton && isEnable && (
                              <Button
                                className={`py-0 px-1 ${
                                  buttonArrange === 'separate'
                                    ? 'mr-auto'
                                    : 'mr-1'
                                }`}
                                variant="outline-primary"
                                onClick={() => selectPanel(index)}
                                disabled={isWaitForSave}
                              >
                                <FeatherIcon icon="check-circle" size="14" />
                              </Button>
                            )}
                            {saveButton && isEnable && (
                              <>
                                {isWaitForSave ? (
                                  <>
                                    <Button
                                      className={`py-0 px-1 ${
                                        buttonArrange === 'separate'
                                          ? 'mr-auto'
                                          : 'mr-1'
                                      }`}
                                      variant="outline-success"
                                      onClick={() => {
                                        if (confirmSave) {
                                          openConfirmSave(index)
                                        } else {
                                          createUpdatePanel(index)
                                        }
                                      }}
                                    >
                                      <FeatherIcon icon="save" size="14" />
                                    </Button>
                                    {!deleteButton && (
                                      <Button
                                        className={`py-0 px-1 ${
                                          buttonArrange === 'separate'
                                            ? 'mr-auto'
                                            : 'mr-1'
                                        }`}
                                        style={{ ...visibility }}
                                        variant="outline-secondary"
                                        onClick={() => {
                                          if (confirmCancel) {
                                            openConfirmCancel(index)
                                          } else {
                                            cancelPanel(index)
                                          }
                                        }}
                                      >
                                        <FeatherIcon icon="x" size="14" />
                                      </Button>
                                    )}
                                  </>
                                ) : (
                                  <Button
                                    className={`py-0 px-1 ${
                                      buttonArrange === 'separate'
                                        ? 'mr-auto'
                                        : 'mr-1'
                                    }`}
                                    variant="outline-warning"
                                    onClick={() => {
                                      if (editActionType === 'modal') {
                                        openEditModal(index)
                                      } else {
                                        updateWaitingState(index)
                                      }
                                    }}
                                  >
                                    <FeatherIcon icon="edit" size="14" />
                                  </Button>
                                )}
                              </>
                            )}
                            {deleteButton && isEnable && (
                              <>
                                {isWaitForSave ? (
                                  <Button
                                    className={`py-0 px-1 ${
                                      buttonArrange === 'separate'
                                        ? 'mr-auto'
                                        : 'mr-1'
                                    }`}
                                    style={{ ...visibility }}
                                    variant="outline-secondary"
                                    onClick={() => {
                                      if (confirmCancel) {
                                        openConfirmCancel(index)
                                      } else {
                                        cancelPanel(index)
                                      }
                                    }}
                                  >
                                    <FeatherIcon icon="x" size="14" />
                                  </Button>
                                ) : (
                                  <Button
                                    className={`py-0 px-1 ${
                                      buttonArrange === 'separate'
                                        ? 'mr-auto'
                                        : 'mr-1'
                                    }`}
                                    style={{ ...visibility }}
                                    variant="outline-danger"
                                    onClick={() => {
                                      if (confirmDelete) {
                                        openConfirmDelete(index)
                                      } else {
                                        onDelete(index)
                                      }
                                    }}
                                  >
                                    <FeatherIcon icon="trash" size="14" />
                                  </Button>
                                )}
                              </>
                            )}
                          </Col>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            )
          })}
        </Row>
      )}
      {isOpenModal === modalDynamicKey && (
        <ModalComponent
          ui={{ ...uischema, key: modalDynamicKey }}
          modalAction={editAction}
          isOpenModal={isOpenModal === modalDynamicKey}
          modalDynamicIndex={modalDynamicIndex}
          designerPropsData={jsonForm.designerPropsData}
          dynamicData={tempDynamic}
          dynamicKey={uischema.key}
        />
      )}
    </>
  )
}

export default PanelSample
